module.exports = __webpack_public_path__ + "img/1577195936.053004ca.jpg";